<template>
	<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_69_118)">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M18.2358 9H31.5791L39.8696 23.0324L48.2425 9H61.4675L39.8696 46.8923L18.2358 9Z" fill="#435466" />
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M4 9L39.8697 71.5263L76 9H61.4676L39.8697 46.8923L18.2359 9H4Z" fill="#4DBA87" />
		</g>
		<defs>
			<clipPath id="clip0_69_118">
				<rect width="80" height="80" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>